<script>
import ReviewsService from '../services/reviews-service.js';
import Cookies from 'js-cookie';
import moment from 'moment';

export default {
  props: ['user', 'teams', 'first_set_up', 'tab'],

  created() {
    // Listen for the 'popstate' event
    window.addEventListener('popstate', this.onPopState);
  },

  beforeDestroy() {
    // Remove the event listener when the component is destroyed
    window.removeEventListener('popstate', this.onPopState);
  },

  async mounted() {
    this.setupTabListeners();
    this.processUrlParameters();
    this.initializePopovers();

    // Fetch reviews stats
    if (Spark?.user?.sub != 'guest_access')
      this.reviewsStats = await ReviewsService.stats(Spark.state.currentTeam.id);

    if (this?.user)
      this.identifyUser();

    // Handle specific tab activation based on props
    this.activateTabByName(this.tab);

    // Show holiday greetings if applicable
    this.showHolidayGreetings();

    // Mark initialization as complete
    this.initialized = true;
  },

  data() {
    return {
      initialized: false,
      reviewsStats: {},
      reviewTabClicked: false,
      teamMetrics: {},
      menuExpanded: false,
      toggle: {
        reputation: false,
        surveys: false,
        instagram: false,
        cases: false,
        marketplace: false,
      },
      isLoading: false,
      xmasDates: {
        start: moment().set({ month: 11, date: 23 }),
        end: moment().set({ month: 11, date: 27 }),
      },
      newYearDates: {
        start: moment().set({ month: 0, date: 1 }),
        end: moment().set({ month: 0, date: 4 }),
      },
    };
  },

  methods: {
    setupTabListeners() {
      $('a[data-toggle="tab"]').on('shown.bs.tab', (e) => {
        const id = e.target.getAttribute('aria-controls');
        this.updatePageViewTrackers(e.target);

        // Emit event for tab activation
        this.$eventHub.$emit('activateTab', id);

        // Update active tab card
        $('[role=tabcard]').removeClass('active');
        $('#' + id).addClass('active');

        //Clear query params
        window.history.pushState(
          {},
          document.title,
          `${window.location.pathname}${this.initialized ? '' : window?.location?.search}${id ? `#${id}` : ''}`
        );
      });
    },

    onPopState(event) {
      // Extract the hash or other info from the current URL
      const hash = window.location.hash.replace('#', '');

      if (hash) {
        this.$eventHub.$emit('activateTab', hash) // Call a method to activate the tab

        // Update active tab card
        $('[role=tabcard]').removeClass('active');
        $('#' + hash).addClass('active');
        $('a[data-toggle="tab"]').removeClass('active');
        $(`a[href*="#${hash}"][aria-controls="${hash}"]`).addClass('active');
      }
    },

    processUrlParameters() {
      const url = new URL(window.location.href);

      // Activate tab based on URL fragment
      const fragment = url.hash.split('#')[1];
      const tabToShow = fragment || 'home';
      $(`.spark-settings-tabs a[href$="#${tabToShow}"]`).tab('show');

      // Activate tab based on query parameter
      if (url.searchParams.get('q') === 'filter') {
        $('.spark-settings-tabs a[href$="#reviews"]').tab('show');
      }
    },

    initializePopovers() {
      setTimeout(() => {
        $('[data-toggle="popover"]').popover();
      }, 1000);
    },

    async identifyUser() {
      if (typeof $crisp !== 'undefined') {
        $crisp.push(['set', 'user:email', [this.user.email]]);
        $crisp.push(['set', 'user:nickname', [this.user.name]]);
        $crisp.push(['set', 'user:company', [Spark.state.currentTeam.name]]);
      }
    },

    activateTabByName(tabName) {
      if (this.toggle.hasOwnProperty(tabName)) {
        this.toggle[tabName] = true;
      }
    },

    showHolidayGreetings() {
      if (this.isHoliday(this.xmasDates) && !this.getCookie('xmas-alert-seen')) {
        this.showAlert(
          'Merry Christmas',
          'The GuestFlip team wishes you and your loved ones a Merry Christmas and a happy holiday season! May this time be filled with joy, love, and warmth.',
          '/assets/img/merry-christmas.webp',
          this.setCookie.bind(this, 'xmas-alert-seen')
        );
      }

      if (this.isHoliday(this.newYearDates) && !this.getCookie('new-year-alert-seen')) {
        this.showAlert(
          'Happy New Year',
          'The GuestFlip team wishes you and your loved ones a happy and prosperous New Year! We hope that the new year brings you good health, success, and happiness.',
          '/assets/img/new-year.webp',
          this.setCookie.bind(this, 'new-year-alert-seen')
        );
        // this.$eventHub.$emit('fireworks-trigger');
      }
    },

    isHoliday(dates) {
      const now = moment();
      return now >= dates.start && now <= dates.end;
    },

    getCookie(cookieName) {
      return Cookies.get(cookieName);
    },

    setCookie(cookieName) {
      Cookies.set(cookieName, 'true', { expires: 11 });
    },

    showAlert(title, text, imageUrl, onConfirm) {
      swal(
        {
          title,
          text,
          imageUrl,
          imageWidth: 400,
          imageHeight: 200,
          imageAlt: title,
        },
        async (result) => {
          if (result) onConfirm();
        }
      );
    },

    requestQuote() {
      this.isLoading = true;
      axios
        .post(`/api/teams/${Spark.state.currentTeam.id}/request-quote`)
        .then(() => {
          this.message =
            'Thank you for your interest! Our team will get back to you with a quote within 24 hours.';
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    toggleExpandMenu() {
      this.menuExpanded = !this.menuExpanded;
    },

    updatePageViewTrackers(target) {
      // Track virtual page views in Segment & Google Analytics
      analytics.page({
        title: target.text,
        path: `/#${target.getAttribute('aria-controls')}`,
      });
    },
  },
};
</script>
